module.exports = __webpack_public_path__ + "static/media/icon_pencil_square.f31b8ae5.svg";